/* jshint esversion: 8 */
import React from 'react';
import '../assets/scss/navbar.scss';
import { Link } from 'react-router-dom';

const version='2.9.1';

const Footer = () => {
    return (
        <div className='footer'>
            <span className='footer-item'>v{version}</span>
            <span className='footer-item'><Link to='/impressum'>Impressum</Link></span>
            <span className='footer-item'><Link to='/datenschutz'>Datenschutz</Link></span>
        </div>
    );
};

export default Footer;
